import {FC, useEffect, useState} from "react";
import {Box, Stack} from "@mui/material";
import {AdminHeader} from "../../AdminHeader";
import Filters from "./components/Filters/Filters";
import TileList from "./components/Widgets/WidgetList";
import LessonsCompletedChart from "./components/LessonsCompletedChart";
import CompletedLessonsDataGrid from "./components/DataGrids/CompletedLessonsDataGrid";
import {useSSTranslation} from "@/i18n/useSSTranslation";
import {DateRangeFilterType, TeamProgressWidget} from "@/enums";
import CompletedCoursesDataGrid
	from "@/pages/ManagerView/Pages/TeamProgress/components/DataGrids/CompletedCoursesDataGrid";
import ActiveUsersDataGrid from "./components/DataGrids/ActiveUsersDataGrid";
import TimeInTrainingDataGrid from "./components/DataGrids/TimeInTrainingDataGrid";
import InActiveUsersDataGrid from "./components/DataGrids/InActiveUsersDataGrid";
import OverdueLessonsDataGrid from "@/pages/ManagerView/Pages/TeamProgress/components/DataGrids/OverdueLessonsDataGrid";
import {useTeamProgressContext} from "@/contexts/TeamProgressContext";
import dayjs from "dayjs";

export const AdminTeamProgressPage: FC = () => {
	const {setFilters} = useTeamProgressContext();
	const [selectedTile, setSelectedTile] = useState<string>(TeamProgressWidget.completedLessons);
	const {t} = useSSTranslation();

	useEffect(() => {
		setFilters({
			archivedUsers: false,
			dateRangeType: DateRangeFilterType.lastWeek,
			dateFrom: dayjs().startOf("week").toDate(),
			dateTo: dayjs().startOf("day").toDate()
		})
	}, []);

	return(
		<Box sx={{display: "flex", justifyContent: "center"}}>
			<Stack sx={{maxWidth: "1444px", width: "100%"}} gap={2}>
				<Stack
					direction='row'
					sx={{
						justifyContent: "space-between",
						alignItems: "flex-start"
					}}
				>
					<AdminHeader
						title={t("team_progress_title", "Team Progress")}
						subtitle={t("team_progress_subtitle", "Monitor learning engagement and employee progress")}
					/>
					<Filters />
				</Stack>
				<Stack
					gap={2}
					direction={{xs: "column-reverse", lg: "row"}}
					sx={{height: {lg: "448px"}}}
				>
					<Box sx={{width: {xs: "100%", lg: "50%"}}} >
						<TileList
							selectedTile={selectedTile}
							setSelectedTile={setSelectedTile}
						/>
					</Box>
					<Box sx={{width: {xs: "100%", lg: "50%"}}}><LessonsCompletedChart /></Box>
				</Stack>
				<Box>
					{selectedTile === TeamProgressWidget.completedLessons && (
						<CompletedLessonsDataGrid />
					)}
					{selectedTile === TeamProgressWidget.completedCourses && (
						<CompletedCoursesDataGrid />
					)}
					{selectedTile === TeamProgressWidget.activeUsers && (
						<ActiveUsersDataGrid />
					)}
					{selectedTile === TeamProgressWidget.timeInTraining && (
						<TimeInTrainingDataGrid />
					)}
					{selectedTile === TeamProgressWidget.inactiveUsers && (
						<InActiveUsersDataGrid />
					)}
					{selectedTile === TeamProgressWidget.usersWithOverdueLessons && (
						<OverdueLessonsDataGrid />
					)}
				</Box>
			</Stack>
		</Box>
	);
}